//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/*
This directive is used to create a fade effect at the bottom of scroll containers.
Use this effect in places where it may not be obvious that you can scroll to see more.
 */

(function() {
  angular.module('curalate')
    .directive('scrollMask', () => ({
      restrict: 'E',
      transclude: true,
      scope: {
        buffer: '&',
        maxHeight: '&',
      },
      template: '<scroll-mask-body ng-transclude></scroll-mask-body><scroll-mask-mask ng-style="{height: maskHeight}"></scroll-mask-mask>',
      link(scope, element) {
        const maxMaskHeightDefault = 40;
        const maskBody = element.children('scroll-mask-body');

        scope.maskHeight = scope.maxHeight() || maxMaskHeightDefault;

        const adjustMask = function() {
          const clippedContentHeight = maskBody[0].scrollHeight - maskBody[0].offsetHeight - maskBody[0].scrollTop;
          const maskHeight = clippedContentHeight < (scope.buffer() || 0) ? 0 : scope.maxHeight() || maxMaskHeightDefault;
          scope.maskHeight = maskHeight;
        };

        maskBody.on('scroll', () => {
          scope.$apply(adjustMask);
        });

        scope.$on('scroll-mask:adjust-mask', adjustMask);
      },
    }))

    .directive('scrollMaskRefresh', ['$timeout', function($timeout) {
      return {
        restrict: 'EA',
        link(scope) {
          $timeout(() => {
            scope.$emit('scroll-mask:adjust-mask');
          });
        },
      };
    }]);
})();
